import { useColorMode } from "../../hooks/useColorMode";
import { formatAuthCallbackError } from "../../lib/authCallbackErrorMessage";
import { apiUrl } from "../../lib/tenantOrigin";
import { navigate, routes, useCurrentUrl } from "../../lib/urls";
import { SignInErrorOrLogout } from "./SignInErrorOrLogout";
import { signOut } from "./lib/sso";

/** `/auth/error?…` after API redirect (see `routes/auth.ts`). */
export function AuthError() {
  useColorMode({ bindListeners: true });

  const { error, error_description } = useCurrentUrl(routes.authError);
  const message = formatAuthCallbackError(error, error_description);

  // "Try again" silently re-asserts the same IdP identity, so also offer a sign-out.
  const wrongAccountEmail =
    error === "signup_disabled" ? error_description : undefined;

  return (
    <SignInErrorOrLogout
      error={message}
      detail={
        wrongAccountEmail ? (
          <>
            Attempted to sign in as: <strong>{wrongAccountEmail}</strong>
          </>
        ) : undefined
      }
      onPrimaryAction={() => navigate(routes.home)}
      primaryActionLabel="Try again"
      secondaryAction={
        wrongAccountEmail
          ? {
              label: `Log out ${wrongAccountEmail}`,
              onPress: () => void signOut(apiUrl()),
            }
          : undefined
      }
    />
  );
}
